import * as TYPES from './mutationTypes';

export default {
  [TYPES.GET_CURRENT_LOCATIONS](state, response) {
    state.getCurrentLocations = response;
  },

  [TYPES.GET_LOCATION](state, response) {
    state.currentLocation = response;
  },
};
